<template>
    <div>
        <van-nav-bar title="佣金" left-text="" left-arrow @click-left="$router.push('/member/agency')" />
        <van-tabs v-model="active">
            <van-tab title="佣金余额">
                <AgentCommissionDetails />
            </van-tab>
            <van-tab title="提现">
                <AgentWithdrawalDetails />
            </van-tab>
            <van-tab title="管理费">
                <ManageCost />
            </van-tab>
            <van-tab title="递延费总额">
                <DeferredCost />
            </van-tab>
            <van-tab title="利润分成">
                <DividedCost />
            </van-tab>
            <van-tab title="会员管理奖">
                <VoucherCost />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import AgentCommissionDetails from "@/components/AgentCommissionDetails";
import AgentWithdrawalDetails from "@/components/AgentWithdrawalDetails";
import ManageCost from "@/components/ManageCost";
import DeferredCost from "@/components/DeferredCost";
import DividedCost from "@/components/DividedCost";
import VoucherCost from "@/components/VoucherCost";
export default {
    name: "AgentDepot",
    data() {
        return {
            active: 0,
            isLoading: false,
            finished: false,
        }
    },
    components: {
        AgentCommissionDetails,
        AgentWithdrawalDetails,
        ManageCost,
        DeferredCost,
        DividedCost,
        VoucherCost
    },
    methods: {
        isLogin() {
            let that = this;
            if (!that.$store.state.loginType) {
                that.$router.push('/login')
            } else {
                if (this.$route.params.tab) {
                    this.active = parseInt(this.$route.params.tab);
                } else {
                    this.active = 0;
                }
            }
        },
    },
    mounted: function () {
        let that = this;
        that.isLogin();
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AgentDepot.vue